module.exports = __webpack_public_path__ + "assets/img/2.6b3ddbd4.png";